import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=22028e54&scoped=true&"
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"
import style0 from "./order-details.vue?vue&type=style&index=0&id=22028e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22028e54",
  null
  
)

export default component.exports